import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sx", "children", "TransitionComponent", "onClickAway"];
import PropTypes from 'prop-types';
import * as React from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Fade from '@mui/material/Fade';
import MuiPopper from '@mui/material/Popper';
import { extendSX } from '../helpers';
import { Paper } from '../indexMaterial';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Popper](https://ui-packages.isbuildingluma.com/ui-core/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://ui-packages.isbuildingluma.com/ui-core/api/popper/)
 * - inherits [MuiPopper API](https://mui.com/material-ui/api/popper/)
 */
const Popper = /*#__PURE__*/React.forwardRef(function Popper(_ref, ref) {
  var _Paper, _Paper2;
  let {
      sx,
      children,
      TransitionComponent = Fade,
      onClickAway
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MuiPopper, _extends({
    ref: ref,
    sx: extendSX(sx, theme => ({
      zIndex: theme.zIndex.appBar + 1
    })),
    placement: "bottom",
    transition: true
    // Skip passing the click event to the parent behind the popper
    ,
    onClick: event => event.stopPropagation()
  }, rest, {
    children: ({
      TransitionProps
    }) => {
      if (onClickAway) {
        return /*#__PURE__*/_jsx(ClickAwayListener, {
          onClickAway: onClickAway,
          children: /*#__PURE__*/_jsx(TransitionComponent, _extends({}, TransitionProps, {
            children: _Paper || (_Paper = /*#__PURE__*/_jsx(Paper, {
              elevation: 8,
              children: children
            }))
          }))
        });
      }
      return /*#__PURE__*/_jsx(TransitionComponent, _extends({}, TransitionProps, {
        children: _Paper2 || (_Paper2 = /*#__PURE__*/_jsx(Paper, {
          elevation: 8,
          children: children
        }))
      }));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Popper.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "PopperProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.any
} : void 0;
export default Popper;